/**
 * Display Discount strikethrough on the product page and quick shop
 *
 * ProductForm (ProductForm-8f1768bf.js) rewrites the price paid on every variant
 * change, but it only rewrites the strikethrough when the variant has a real
 * compare-at price. Under a Display Discount there is no compare-at price - the
 * strikethrough is the variant's full price - so it was left showing whatever the
 * server rendered while the price paid moved on.
 *
 * WHY A SEPARATE, UNHASHED FILE: the bundle's source is not in this repo (see
 * CLAUDE.md). This file watches the price span ProductForm writes to and, when the
 * Display Discount applies and the variant has no compare-at price, sets the
 * strikethrough to the same variant's undiscounted price. It asks the form itself
 * (shouldDisplayDiscount, variantFromSelectedOptions), so it cannot disagree with
 * the price paid.
 */
(function () {
  'use strict';

  var PRICE = '[data-product-form-external-element="price"]';

  // Same output as the bundle's formatter (currency.js, cents in, ".00" dropped).
  function format(cents) {
    var parts = (Math.round(cents) / 100).toFixed(2).split('.');
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return ('$' + dollars + '.' + parts[1]).replace('.00', '');
  }

  function formFor(priceEl) {
    var forms = document.querySelectorAll('product-form');
    for (var i = 0; i < forms.length; i++) {
      try {
        var els = forms[i].externalEls;
        if (els && els.price && els.price.element === priceEl) return forms[i];
      } catch (e) {}
    }
    return forms.length === 1 ? forms[0] : null;
  }

  function apply(priceEl) {
    var form = formFor(priceEl);
    if (!form || !form.product) return;

    var sale;
    try {
      sale = form.externalEls.priceSale;
    } catch (e) {
      return;
    }
    if (!sale || !sale.element) return;

    var variant = form.variantFromSelectedOptions || form.product.variants[0];
    if (!variant || variant.compare_at_price || !form.shouldDisplayDiscount) return;

    var qtyInput = form.querySelector('input[name="quantity"]');
    var qty = parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;
    var text = format(variant.price * qty);

    if (sale.element.textContent.trim() !== text) sale.element.textContent = text;
  }

  function handle(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      var el = target.nodeType === 1 ? target : target.parentElement;
      if (el && el.matches && el.matches(PRICE)) apply(el);
    }
  }

  new MutationObserver(handle).observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();
